import React from 'react';
import Hero from './components/Hero';
import Story from './components/Story';
import Services from './components/Services';
import Projects from './components/Projects';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <Story />
      <Services />
      <Projects />
    </main>
  );
};

export default HomePage;
